import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {Menu} from './menu.component';
import {authGuard, campaignGuard} from 'gamesis-auth';
import {LoginPage} from './public/login';

const routes: Routes = [
    {
        path: 'login',
        component: LoginPage
    },
    {
        path: 'select',
        canActivate: [authGuard],
        loadChildren: () => import('./campaigns/campaigns.module').then(m => m.CampaignsModule)
    },
    {
        path: 'story',
        component: Menu,
        canActivate: [campaignGuard, authGuard],
        children: [{
            path: '',
            loadChildren: () => import('./story/story.module').then(m => m.StoryModule)
        }]
    }, {
        path: 'players',
        component: Menu,
        canActivate: [campaignGuard, authGuard],
        children: [{
            path: '',
            loadChildren: () => import('./players/players.module').then(m => m.PlayersModule)
        }]
    }, {
        path: 'characters',
        component: Menu,
        canActivate: [campaignGuard, authGuard],
        children: [{
            path: '',
            loadChildren: () => import('./characters/characters.module').then(m => m.CharactersModule)
        }]
    }, {
        path: '**',
        redirectTo: 'select'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: PreloadAllModules,
            useHash: false
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
